import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import ReCAPTCHA from 'react-google-recaptcha';

import { Keys } from '../../constants/keys-constants';
import { REASONS_FOR_SUPPORT_CONTACT } from '../../constants/contact-constants';
import { isEmail } from '../../helpers/validation-helper';
import '../../styles/forms/contact-form.scss';

const validate = (values, props) => {
  const errors = {};

  if (!values.givenName) {
    errors.givenName = 'Please provide your name';
  }

  if (!values.familyName) {
    errors.familyName = 'Please provide your name';
  }

  if (!values.emailAddress) {
    errors.emailAddress = 'Please provide your email address';
  } else if (!isEmail(values.emailAddress)) {
    errors.emailAddress = 'Invalid email address';
  }

  if (props.isShowReason && !values.reason) {
    errors.reason = 'Please provide a reason for contacting us to get you a quicker response';
  }

  if (!values.message) {
    errors.message = 'Please provide a message';
  }

  if (!values.captchaResponse) {
    errors.captchaResponse = 'Filling recaptcha is required.';
  }

  return errors;
};

/* eslint-disable react/prop-types */
const renderField = ({ id, input, label, placeholder, meta: { touched, error } }) => (
  <div className="col-12 col-sm-6">
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      <input className="form-control" id={id} {...input} placeholder={placeholder} />
      {touched && (error && <div className="invalid-feedback d-block">{error}</div>)}
    </div>
  </div>
);

const renderTextareaField = ({ id, input, label, placeholder, meta: { touched, error } }) => (
  <div className="form-group">
    <label htmlFor={id}>{label}</label>
    <textarea className="form-control" id={id} {...input} placeholder={placeholder} rows="5" />
    {touched && (error && <div className="invalid-feedback d-block">{error}</div>)}
  </div>
);

const renderSelectField = ({ id, label, input, children, meta: { touched, error } }) => (
  <div className="col-12">
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      <select
        className="form-control"
        id={id}
        onChange={event => input.onChange(event.target.value)}
      >
        {children}
      </select>
      {touched && (error && <div className="invalid-feedback d-block">{error}</div>)}
    </div>
  </div>
);

const renderCaptchaField = ({ input, meta: { touched, error } }) => (
  <div className="form-group">
    <ReCAPTCHA sitekey={Keys.RECAPTCHA_CLIENT_SITEKEY} onChange={input.onChange} />
    {touched && (error && <span className="invalid-feedback d-block">{error}</span>)}
  </div>
);
/* eslint-enable react/prop-types */

class ContactForm extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    isShowReason: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    title: '',
    isShowReason: false,
  };

  render() {
    const { title, isShowReason, handleSubmit } = this.props;

    return (
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="contact-form__container container">
          {title && <h3 className="mb-3 mt-3">{title}</h3>}
          <div className="row">
            <Field
              id="givenName"
              name="givenName"
              component={renderField}
              label="First Name"
              placeholder="First Name"
            />
            <Field
              id="familyName"
              name="familyName"
              component={renderField}
              label="Last Name"
              placeholder="Last Name"
            />
          </div>
          <div className="row">
            <Field
              id="emailAddress"
              name="emailAddress"
              component={renderField}
              label="Email"
              placeholder="Email Address"
            />
            <Field
              id="phoneNumber"
              name="phoneNumber"
              component={renderField}
              label="Phone"
              placeholder="Phone Number"
            />
          </div>
          {isShowReason && (
            <div className="row">
              <Field
                id="reason"
                name="reason"
                component={renderSelectField}
                label="Reason For Contact"
              >
                {REASONS_FOR_SUPPORT_CONTACT.map(reason => (
                  <option value={reason.value} key={`contact-reason-key=${reason.text}`}>
                    {reason.text}
                  </option>
                ))}
              </Field>
            </div>
          )}
          <Field
            id="message-body"
            name="message"
            component={renderTextareaField}
            label="Message"
            placeholder="Write your message"
          />
          <Field name="captchaResponse" component={renderCaptchaField} />
          <div className="form-group">
            <button
              type="submit"
              className="contact-form__button button button-large button-purple button-rounded"
            >
              Send Message
            </button>
          </div>
        </div>
      </form>
    );
  }
}

const createReduxForm = reduxForm({ form: 'contact', validate });

export default createReduxForm(ContactForm);
